import { useContext } from 'react';
import { Formik, Form } from 'formik';
import { Container } from '@mui/material';
import { CircleLoader } from 'components';
import { AbsenceForm } from './components';
import { absenceSchema, absenceContext } from './AbsenceDetailsContext';

let Absences = () => {
    let service = useContext(absenceContext);

    return (
        <Container>
            <Formik
                enableReinitialize={true}
                initialValues={service.absence}
                validationSchema={absenceSchema}
                onSubmit={(values, action) => {
                    service.saveAbsence(values);
                    action.setSubmitting(false);;
                }}
            >
                <Form>
                    {service.isLoading && <CircleLoader />}
                    {service.isLoading === false && <AbsenceForm />}
                </Form>
            </Formik>
        </Container>
    )
}

export default Absences;